import request from "@/config/axios";
// 获取分类列表
export const getAppList = (params) => {
  return request.get({ url: "/category_item/get_category_list", params });
};

// 查询所有系统
export const getSysList = (params) => {
  return request.get({ url: "/sysPlatform/list", params });
};

// 根据分类获取应用列表
export const getAppListByCategory = (data) => {
  return request.post({ url: "/sysPlatform/idsList", data });
};

// 获取用户信息
export const getUserInfo = (params) => {
  return request.get({ url: "/portalApi/get_user_name", params });
};

// 注册用户
export const regUser = (data) => {
  return request.get({ url: "/portalApi/regUser", data });
};

// 退出登录
export const logout = (params) => {
  return request.get({ url: "/portalApi/logout", params });
};

// 查询门户配置
export const getPortalConfig = (params) => {
  return request.get({ url: "/portalConfig/get", params });
};

//
export const getList = (params) => {
  return request.get({
    url: "/sysPlatform/list",
    params,
  });
};

// 登录 跳转接口
export const getLoginApi = (params) => {
  return request.get({ url: window.g.loginUrl, params });
};

// 角色列表
export const getRoleList = (params) => {
  return request.get({
    url: "/sysPlatform/get_role_list",
    params,
  });
};

// 产品列表
export const getProductList = (params) => {
  return request.get({
    url: "/sysPlatform/get_porduct_list",
    params,
  });
};

// 平台列表
export const getPlatformList = (params) => {
  return request.get({
    url: "/sysPlatform/query_list",
    params,
  });
};
